module.exports = __webpack_public_path__ + "static/media/pix_pagarme.78c71387.png";